"use client";

import { useCallback } from "react";
import { useToast, type ToastOptions } from "@/components/providers/FetchToastProvider";
import { BUILDER_TOAST_DURATION } from "../_logic/constants";

/** Return type for useBuilderToast */
interface BuilderToast {
  showToast: (message: string, type?: "success" | "error", options?: ToastOptions) => void;
}

/** useToast wrapper with shorter default duration for the landing page builder. Memoized so
 *  callers can safely put `showToast` in an effect/callback dependency array without it
 *  re-triggering on every render. */
export const useBuilderToast = (): BuilderToast => {
  const { showToast } = useToast();

  const showBuilderToast = useCallback(
    (message: string, type?: "success" | "error", options?: ToastOptions) =>
      showToast(message, type, { duration: BUILDER_TOAST_DURATION, ...options }),
    [showToast]
  );

  return { showToast: showBuilderToast };
};
